import React from 'react';
import { TextBody, ScreenReaderOnly } from '@ally/metronome-ui';
import { Private } from '@ally/private';
import { formatCurrency } from '@ally/aos-utils';
import { formattedDate, maskAccount, spreadNumberA11y, getWithdrawalMessage, } from '../utils';
import { UL, LI, StyledDL, StyledDT, StyledDD } from './SharedStyles';
export const AchProcessingDescription = () => {
    return (React.createElement(UL, null,
        React.createElement(LI, null, "We've started processing your transfer. You can no longer edit or cancel this transfer."),
        React.createElement(LI, null, "We'll let you know when we've delivered your funds."),
        React.createElement(LI, null, "Your transfer may appear to be processing even after the funds have posted.")));
};
export const AchDeliveredDescription = () => {
    return (React.createElement(TextBody, { tag: "p", size: "sm" }, "We've delivered your funds. Your transfer is complete."));
};
export const StatusModalAchDetails = ({ event }) => {
    // Shared AchEvent | InternalEvent
    const { eventModelData: { fromAccountName, fromAccountNumber, toAccountName, toAccountNumber, transferAmount, transferFrequency, }, statuses, transactionId, } = event;
    // AchEvent Only
    const { eventModelData: { fromAccountNameNumber, toAccountNameNumber, achRecurringEndDate, deliverOnDate, withdrawalDate, transferSpeed, transferFee, }, } = event;
    const fromInfoAvailable = fromAccountName && fromAccountNumber;
    const toInfoAvailable = toAccountName && toAccountNumber;
    const isRecurring = transferFrequency === 'Recurring';
    const processingDate = statuses && statuses.find(history => history.status === 'InProcess');
    const isStandardSpeed = transferSpeed === 'Standard';
    const displaySpeed = isStandardSpeed ? '3 business days' : '1 business day';
    return (React.createElement(StyledDL, null,
        React.createElement(StyledDT, null, "From"),
        React.createElement(StyledDD, null,
            React.createElement(Private, null, fromInfoAvailable
                ? maskAccount(fromAccountName, fromAccountNumber)
                : fromAccountNameNumber)),
        React.createElement(StyledDT, null, "To"),
        React.createElement(StyledDD, null,
            React.createElement(Private, null, toInfoAvailable
                ? maskAccount(toAccountName, toAccountNumber)
                : toAccountNameNumber)),
        React.createElement(StyledDT, null, "Amount"),
        React.createElement(StyledDD, null, formatCurrency.asCurrency(transferAmount)),
        React.createElement(StyledDT, null, "Frequency"),
        React.createElement(StyledDD, null, transferFrequency),
        isRecurring && achRecurringEndDate && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, null, "End"),
            React.createElement(StyledDD, null, formattedDate(achRecurringEndDate, 'MMM D, YYYY')))),
        processingDate && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, null, "Processing"),
            React.createElement(StyledDD, null, formattedDate(processingDate.eventDateTime, 'MMM D, YYYY')))),
        deliverOnDate && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, null, "Deliver On"),
            React.createElement(StyledDD, null,
                formattedDate(deliverOnDate, 'MMM D, YYYY'),
                React.createElement("br", null),
                getWithdrawalMessage(withdrawalDate)))),
        transferSpeed && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, null, "Transfer Speed"),
            React.createElement(StyledDD, null, displaySpeed))),
        (transferFee || transferFee === 0) && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, null, "Fee"),
            React.createElement(StyledDD, null, formatCurrency.asCurrency(transferFee)))),
        React.createElement(StyledDT, null, "Reference #"),
        React.createElement(StyledDD, null,
            React.createElement(TextBody, { tag: "span", size: "sm", "aria-hidden": "true" }, transactionId),
            React.createElement(ScreenReaderOnly, null, spreadNumberA11y(transactionId)))));
};
//# sourceMappingURL=StatusModalAchData.js.map